// context/ScrollContext.tsx

import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ScrollContextType {
  showHeader: boolean;
  isBannerSticky: boolean;
}

const ScrollContext = createContext<ScrollContextType>({
  showHeader: true,
  isBannerSticky: false,
});

export const ScrollProvider = ({ children }: { children: ReactNode }) => {
  const [showHeader, setShowHeader] = useState(true);
  const [isBannerSticky, setIsBannerSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
       setShowHeader(scrollY <= 40);
      setIsBannerSticky(scrollY > 40);
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ScrollContext.Provider value={{ showHeader, isBannerSticky }}>
      {children}
    </ScrollContext.Provider>
  );
};

export const useScrollContext = () => useContext(ScrollContext);
